import { useCallback, useState } from 'react';

import type { StepperFlow } from '../../types';
import { Step } from '../../types';

export type UseCustomPacingStepperResponse = {
  step: Step;
  goToStep: (step: Step) => void;
  initiateFlow: (flow: StepperFlow) => void;
  goToPrevStep: () => void;
};

const useCustomPacingStepper = (): UseCustomPacingStepperResponse => {
  const [step, setStep] = useState<Step>(Step.Initial);
  const [stepperFlow, setStepperFlow] = useState<StepperFlow>();

  const goToStep = useCallback((step: Step): void => {
    setStep(step);
  }, []);

  const initiateFlow = useCallback((flow: StepperFlow): void => {
    setStepperFlow(flow);
  }, []);

  const backFromResultStep = useCallback((): void => {
    if (stepperFlow) {
      setStep(stepperFlow);
    } else {
      setStep(Step.Initial);
    }
  }, [stepperFlow]);

  const goToPrevStep = useCallback((): void => {
    if (step === Step.CSVUpload || step === Step.SetCPSchedule || step === Step.ReportList) {
      setStep(Step.Initial);
    }

    if (step === Step.Result) {
      backFromResultStep();
    }
  }, [backFromResultStep, step]);

  return {
    step,
    goToStep,
    initiateFlow,
    goToPrevStep,
  };
};

export default useCustomPacingStepper;
